import Vue from 'vue';
import Router from 'vue-router';
import { hasToken } from '../utils/auth';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    redirect: '/overview'
  },
  {
    path: '/overview',
    name: 'overview',
    component: () => import('../views/OverviewDashboard.vue'),
    meta: { requiresAuth: true, title: '基础总览' }
  },
  {
    path: '/tracking-quality',
    name: 'trackingQuality',
    component: () => import('../views/TrackingQualityDashboard.vue'),
    meta: { requiresAuth: true, title: '埋点质量' }
  },
  {
    path: '/tracking-entry',
    name: 'trackingEntry',
    component: () => import('../views/TrackingEntryDashboard.vue'),
    meta: { requiresAuth: true, title: '入口点击' }
  },
  {
    path: '/tracking-dwell',
    name: 'trackingDwell',
    component: () => import('../views/TrackingDwellDashboard.vue'),
    meta: { requiresAuth: true, title: '停留时长' }
  },
  {
    path: '/tracking-evaluation',
    name: 'trackingEvaluation',
    component: () => import('../views/TrackingEvaluationDashboard.vue'),
    meta: { requiresAuth: true, title: '版本评估' }
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('../views/LiveDashboard.vue'),
    meta: { requiresAuth: true, title: '直播统计' }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileDashboard.vue'),
    meta: { requiresAuth: true, title: '用户画像' }
  },
  {
    path: '/customer-risk/overview',
    name: 'customerRiskOverview',
    component: () => import('../views/CustomerRiskOverview.vue'),
    meta: { requiresAuth: true, title: '客户情绪与风险总览' }
  },
  {
    path: '/customer-risk/customers',
    name: 'customerRiskCustomers',
    component: () => import('../views/CustomerRiskCustomers.vue'),
    meta: { requiresAuth: true, title: '重点客户池' }
  },
  {
    path: '/customer-risk/events',
    name: 'customerRiskEvents',
    component: () => import('../views/CustomerRiskEvents.vue'),
    meta: { requiresAuth: true, title: '风险事件中心' }
  },
  {
    path: '/customer-risk/events/:eventId',
    name: 'customerRiskEventDetail',
    component: () => import('../views/CustomerRiskEventDetail.vue'),
    meta: { requiresAuth: true, title: '风险事件详情', activeMenu: 'customerRiskEvents' }
  },
  {
    path: '/customer-risk/teams',
    name: 'customerRiskTeams',
    component: () => import('../views/CustomerRiskTeams.vue'),
    meta: { requiresAuth: true, title: '团队风险视图' }
  }
];

const router = new Router({
  mode: 'hash',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    if (hasToken()) {
      next('/overview');
      return;
    }
    next();
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth) && !hasToken()) {
    next('/login');
    return;
  }

  next();
});

export default router;
